var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 16.6C13.645 16.6 16.6 13.645 16.6 9.99996C16.6 6.35489 13.645 3.39997 9.99996 3.39997C6.35489 3.39997 3.39997 6.35489 3.39997 9.99996C3.39997 13.645 6.35489 16.6 9.99996 16.6ZM9.99996 17.8571C14.3393 17.8571 17.8571 14.3393 17.8571 9.99996C17.8571 5.66058 14.3393 2.14282 9.99996 2.14282C5.66058 2.14282 2.14282 5.66058 2.14282 9.99996C2.14282 14.3393 5.66058 17.8571 9.99996 17.8571Z",
    fill: "#CAD4DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6535 14.9936C12.26 13.7806 12.6714 12.0168 12.6714 9.99996C12.6714 7.98312 12.26 6.21937 11.6535 5.00634C11.0094 3.71811 10.3521 3.39997 9.99996 3.39997C9.64782 3.39997 8.99058 3.71811 8.34647 5.00634C7.73995 6.21937 7.32854 7.98312 7.32854 9.99996C7.32854 12.0168 7.73995 13.7806 8.34647 14.9936C8.99058 16.2818 9.64782 16.6 9.99996 16.6C10.3521 16.6 11.0094 16.2818 11.6535 14.9936ZM9.99996 17.8571C12.1697 17.8571 13.9285 14.3393 13.9285 9.99996C13.9285 5.66058 12.1697 2.14282 9.99996 2.14282C7.83027 2.14282 6.07139 5.66058 6.07139 9.99996C6.07139 14.3393 7.83027 17.8571 9.99996 17.8571Z",
    fill: "#CAD4DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.983 10.6285H3.01475V9.37139H16.983V10.6285Z",
    fill: "#CAD4DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.321f2f72efee2eabea369ba763aca0ce.svg";
export { ForwardRef as ReactComponent };